// extracted by mini-css-extract-plugin
export default {"tableGrid":"tableGrid___zfrsc","formTableContainer":"formTableContainer___iGrWg"};